export default __webpack_public_path__ + "static/media/uploader-oneTouchUltraMini-problem-2.069b2f08.png";